<mat-sidenav-container class="tp-container">
  <!-- Left sidenav section begins -->
  <mat-sidenav mode="side" collapsed class="background-menu-vertical" #sidenav>
    <section class="tp-section">
      <span class="header-logo text-right">
        <a [routerLink]="['/admin/dashboard']" >
          <img
            src="./assets/img/logo.png"
            class="img-fluid border-0"
            alt="TIBCARGO"
          />
        </a>
      </span>
    </section>
    <div style="clear: both"></div>

    <mat-nav-list>
      
      <mat-accordion *ngFor="let item of menus">
           
           <mat-expansion-panel>
              <mat-expansion-panel-header>
                      <mat-panel-title>
                      {{item.nombre}}  
                      </mat-panel-title>
              </mat-expansion-panel-header>
<div *ngFor="let link of item.grupo"> 
              <mat-list-item class="second-level" routerLink="{{link.ruta}}">
                      <!-- Entradas de cada submenú  -->
                              <mat-icon>bookmark</mat-icon>
                              <span style="margin-left:7px">{{link.nombre}}</span>
                      </mat-list-item>
              </div>
             

         
                
        

      </mat-expansion-panel>

      </mat-accordion>

      
       
    </mat-nav-list>
    

  </mat-sidenav>
  <!-- Left sidenav section ends -->
  <!-- Header section begins -->
  <mat-sidenav-content>
    <div fxLayout="row"  fxLayoutGap="10px" class="header-toolbar">
      <div class="col-8">
        <div class="title-admin">
          <button mat-icon-button class="inline">
            <mat-icon (click)="sidenav.toggle()">menu</mat-icon>
          </button>
          <h4>Gestor de Almacén</h4>
        </div>
      </div>
      

      <div fxLayoutAlign="center right">
        <button
          mat-raised-button
          
          class="btn-transparent"
          [matMenuTriggerFor]="opcionesNavs"
        >
          {{ welcome }} <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #opcionesNavs="matMenu">
          <!--<a mat-menu-item [routerLink]="['/home/cambiar-contrasenia']" class="link-sura">Cambiar Contrase&ntilde;a</a>-->
          <a mat-menu-item (click)="cerrarSesion()" class="link-sura"
            >Cerrar Sesión</a
          >
          <a mat-menu-item [routerLink]="['/admin/change-password']" class="link-sura"
            >Cambiar contraseña</a>
        </mat-menu>
      </div>
    </div>
    <div class="divider-line-grey"></div>
    <div class="container">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>


  </mat-sidenav-content>
  <!-- Header section ends --> 
  </mat-sidenav-container
>​


